import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  title: "",
  content: "",
  postType: "TEXT",
  hashTag: [],
  visibility: "PUBLIC",
  media: [],
};

export const createUserPostSlice = () => {
  const userPostSlice = createSlice({
    name: "userPost",
    initialState,
    reducers: {
      setUserPost: (state, action) => {
        return action.payload;
      },
      resetUserPost: () => {
        return initialState;
      },
    },
  });

  return userPostSlice;
};
